document.addEventListener('DOMContentLoaded', function () {
  const toggleBtn = document.getElementById('toggleReferences');
  const refList = document.getElementById('referencesList');
  const arrow = document.getElementById('arrowIcon');

  // Toggle drawer
  if (toggleBtn) {
    toggleBtn.addEventListener('click', function () {
      refList.classList.toggle('hidden');
      arrow.classList.toggle('rotate-180');
    });
  }

  // Handle citation-link clicks
  document.querySelectorAll('.citation-link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      if (refList.classList.contains('hidden')) {
        refList.classList.remove('hidden');
        arrow.classList.add('rotate-180');
      }
      const href = this.getAttribute('href');
      const target = document.querySelector(href);
      if (target) {
        const headerHeight = 250; // Increased offset for more scroll above the citation
        const y = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });
  });

  // Handle up-arrow clicks
  document.querySelectorAll('#referencesList a[href^="#citation-"][href$="-ref"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').replace('#', '');
      const target = document.getElementById(targetId);
      if (target) {
        const headerHeight = 250; // Increased offset for more scroll above the citation
        const y = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });
  });
});
